import { Component, Input } from '@angular/core';

@Component({
  selector: 'sky-additional-device-banner',
  templateUrl: './additional-device-banner.component.html',
  styleUrls: ['./additional-device-banner.component.scss'],
})
export class AdditionalDeviceBannerComponent {
  @Input() numberOfDevices: number | undefined = undefined;
  @Input() price: number | undefined = undefined;
}
